import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const imageGalleryFn = /* @__PURE__ */ createRecipe('image-gallery', {
  "shape": "square"
}, [])

const imageGalleryVariantMap = {
  "shape": [
    "square",
    "fill"
  ]
}

const imageGalleryVariantKeys = Object.keys(imageGalleryVariantMap)

export const imageGallery = /* @__PURE__ */ Object.assign(memo(imageGalleryFn.recipeFn), {
  __recipe__: true,
  __name__: 'imageGallery',
  __getCompoundVariantCss__: imageGalleryFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: imageGalleryVariantKeys,
  variantMap: imageGalleryVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, imageGalleryVariantKeys)
  },
  getVariantProps: imageGalleryFn.getVariantProps,
})